import {BookingInfo, BookingInfoFromJson} from "./BookingInfo";
import {GetWithAuth} from "../client/Get";
import {Json} from "../client/Json";

export async function GetAllUnapprovedBookings(token: any): Promise<BookingInfo[]> {
    const data: Json<BookingInfo>[] = (await GetWithAuth<BookingInfo[]>("/api/bookings/unapproved", token)).data;
    return data.map(r => BookingInfoFromJson(r))
}